import { Children, cloneElement } from 'react';
import noop from 'lodash/noop';
import Downshift from 'downshift';
import { Manager, Popper, Reference } from 'react-popper';
import { Box, NakedButton } from '@qga/roo-ui/components';
import partition from 'lodash/partition';
import { HiddenLabel, DropdownWrapper, DropdownItem } from './primitives';
import { getA11yStatusMessage } from './helpers';

const Dropdown = ({ label, placement = 'bottom', onExpand = noop, onCollapse = noop, children, ...props }) => (
  <Manager>
    <Downshift {...props} getA11yStatusMessage={getA11yStatusMessage}>
      {({ isOpen, getToggleButtonProps, highlightedIndex, getItemProps, getLabelProps, getMenuProps, getRootProps }) => {
        const childrenArray = Children.toArray(children);
        const [items, toggle] = partition(childrenArray, (child) => child.type === Dropdown.item);
        const dropdownContent = items.map((item, index) => {
          const highlighted = highlightedIndex === index;

          return cloneElement(
            item,
            getItemProps({
              highlighted,
              item,
              key: index,
              ...item.props,
            }),
          );
        });

        return (
          // Override default root role: https://github.com/downshift-js/downshift/issues/750
          <Box {...getRootProps({ role: undefined })}>
            <HiddenLabel {...getLabelProps()}>{label}</HiddenLabel>
            <Reference>
              {({ ref }) => {
                const buttonProps = getToggleButtonProps({ ref });
                const onClick = (event) => {
                  if (!isOpen) {
                    onExpand();
                  } else {
                    onCollapse();
                  }
                  buttonProps.onClick(event);
                };
                return (
                  <NakedButton {...buttonProps} onClick={onClick}>
                    {toggle}
                  </NakedButton>
                );
              }}
            </Reference>

            <Popper placement={placement}>
              {({ ref, style }) =>
                isOpen && (
                  <DropdownWrapper {...getMenuProps({ ref })} style={style}>
                    {dropdownContent}
                  </DropdownWrapper>
                )
              }
            </Popper>
          </Box>
        );
      }}
    </Downshift>
  </Manager>
);

Dropdown.item = DropdownItem;
Dropdown.item.displayName = 'Dropdown.item';

export default Dropdown;
